export const API_URL = process.env.VUE_APP_BACKEND_API_URL;
export const APP_URL = process.env.VUE_APP_FRONTEND_URL;
export const PROGRAMMATIC_CAMPAIGNS_API_URL =
    process.env.NODE_ENV === 'local' ? 'http://localhost:3003' : process.env.VUE_APP_PROGRAMMATIC_CAMPAIGNS_API_URL;
export const CREATIVE_HUB_API_URL = process.env.VUE_APP_CREATIVE_HUB_API_URL;
